
export default {
  name: 'VsTableSort',
  inject: ['table'],
  props: {
    prop: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      direction: null
    }
  },
  computed: {
    sorting() {
      const value = this.table.sorting
      return value.prop == this.prop ? value : {}
    },
    asc() {
      return this.sorting.order == 'ascending'
    },
    desc() {
      return this.sorting.order == 'descending'
    },
    styleAttrs() {
      if (this.table.hasData) {
        return { color: 'grey', cursor: 'pointer' }
      } else {
        return { color: 'grey-light', pointerEvents: 'none' }
      }
    }
  },
  methods: {
    onClick(event) {
      event.stopPropagation()

      if (this.sorting.prop != this.prop) {
        this.$set(this.table, 'sorting', { prop: this.prop })
      }

      if (this.asc) {
        this.$set(this.sorting, 'order', 'descending')
      } else if (this.desc) {
        this.$set(this.sorting, 'order', null)
      } else {
        this.$set(this.sorting, 'order', 'ascending')
      }

      this.$emit('change', this.sorting.order)
    }
  }
}
